import { useEffect, useState } from "react";

export const CountUp = ({ value, format = (v) => Math.round(v), duration = 1100, ...rest }) => {
  const [n, setN] = useState(typeof value === "number" ? 0 : value);
  useEffect(() => {
    if (typeof value !== "number" || window.matchMedia("(prefers-reduced-motion: reduce)").matches) { setN(value); return undefined; }
    let raf, t0;
    const step = (t) => { t0 = t0 || t; const p = Math.min((t - t0) / duration, 1); setN(p < 1 ? value * (1 - (1 - p) ** 3) : value); if (p < 1) raf = requestAnimationFrame(step); };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);
  return <span {...rest}>{typeof n === "number" ? format(n) : n}</span>;
};
